<template>
    <div>
        <template v-if="virtual_corporate_transaction_history === true">
            <div>
                <div class="page-top mb-1 mb-3 clearfix">
                    <div class="page-top float-left">
                        <h1 class="m-0">Account Balance: <span class="highlight-color"> (PKR {{formatAmount(account_balance)}})</span> </h1>
                    </div>
                </div>
                <div class="corporate-main">

                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label class="label block-label"> From Date </label>
                            <datepicker name="from_date" v-model="from_date" input-class="datepicker" :bootstrap-styling="true" placeholder="From Date"></datepicker>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label class="label block-label"> To Date </label>
                            <datepicker name="to_date" v-model="to_date" input-class="datepicker" :bootstrap-styling="true" placeholder="To Date"></datepicker>
                        </div>
                    </div>
                    <div class=" form-group col-md-12">
                        <div class=" align-right">
                            <br>
                            <button @click="getVirtualTransactionHistoryData" v-if="!showBtn"  class="btn btn-primary">Submit</button>
                            <button @click="filterTable" v-if="showBtn"  class="btn btn-primary">Submit</button>
                        </div>
<!--                      <div class="align-left">-->
<!--                        <button @click="generateMT940"   class="btn btn-primary" data-toggle="tooltip" data-html="true" title="<em>Report will be generated empty in case no transactions are found for last day!</em>">MT940 Report<sup>(Last 24 Hours)</sup></button>-->
<!--                      </div>-->
                    </div>
                </div>
                    <div class="corporate-head pb-3 clearfix">
                        <h3 class="transaction-history-head float-left"> Transaction History </h3>
                        <div class="dt-buttons" id="buttons">
                            <a _target="_blank" class="dt-button buttons-excel buttons-html5" tabindex="0" aria-controls="newTab" href="javascript::void(0);"  @click="downloadExcel();" ><span><span class="fa fa-file-excel-o"></span>Export</span></a>
                            <a _target="_blank" class="dt-button buttons-excel buttons-html5" tabindex="0" aria-controls="newTab" href="javascript::void(0);"  @click="printTransactions();" ><span><span class="fa fa-file-excel-o"></span>Print</span></a>
                        </div>
                        <!-- <div class="searching float-right">
                            <input id="custom_search" type="text" class="form-control search" autocomplete="off" />
                        </div> -->
                    </div>
                    <table id="dt-table" class="table" style="width:100%">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>TXN ID</th>
                                <th>Transaction Type</th>
                                <th>Description</th>
                                <th>Debit</th>
                                <th>Credit</th>
                                <th>Balance</th>
                                <th>Branch</th>
                            </tr>
                        </thead>
                    </table>
                </div>
            </div>
        </template>
        <template v-else-if="virtual_corporate_transaction_history === null"><preLoader></preLoader></template>
        <template v-else-if="virtual_corporate_transaction_history === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    var dtTable = null;
    export default {
        data() {
            return {
                from_date : '',
                to_date : '',
                ledger : [],
                account_balance: null,
                showBtn: false,
                virtual_corporate_transaction_history: null,
                distributor: false
            };
        },
        methods: {
            filterTable(){
                this.$Progress.start();
                dtTable.draw();
                this.$Progress.finish();
            },
            downloadExcel: function(id){
                this.$Progress.start();
                var formData = {
                    'from_date': moment(this.from_date).format('YYYY-MM-DD'),
                    'to_date': moment(this.to_date).format('YYYY-MM-DD'),
                    'distributor': this.distributor

                }
                axios.post('/api/downloadVRTransactionExcel',formData,{
                    responseType: 'blob'
                })
                .then((response) => {
                    if(response.status == 200){
                        this.$Progress.finish();
                        const url = URL.createObjectURL(new Blob([response.data], {
                            type: 'application/vnd.ms-excel'
                        }))

                        const link = document.createElement('a')
                        link.href = url
                        link.setAttribute('download', 'transaction_history.xlsx')
                        document.body.appendChild(link)
                        link.click()
                        this.$Progress.finish();
                    }else{
                        this.showAlertBox('error','There is some problem');
                    }

                }).catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                    this.showAlertBox('error','There is some problem');
                });
            },
            printTransactions: function(id){
                this.$Progress.start();
                var formData = {
                    'from_date': moment(this.from_date).format('YYYY-MM-DD'),
                    'to_date': moment(this.to_date).format('YYYY-MM-DD'),
                    'distributor': this.distributor
                }
                axios.post('/api/printVRTransaction',formData)
                .then((response) => {
                    if(response.status == 200){
                        this.$Progress.finish();
                        var mywindow = window.open('', 'PRINT', 'height=400,width=600');
                        // mywindow.document.write('<html><head><title>' + document.title  + '</title>');
                        // mywindow.document.write('</head><body >');
                        // mywindow.document.write('<h1>' + document.title  + '</h1>');
                        mywindow.document.write(response.data);
                        // mywindow.document.write('</body></html>');
                        mywindow.document.close(); // necessary for IE >= 10
                        mywindow.focus(); // necessary for IE >= 10*/
                        mywindow.print();
                        // mywindow.close();
                        return true;
                    }else{
                        this.showAlertBox('error','There is some problem');
                    }

                }).catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','There is some problem');
                });
            },

            getVirtualTransactionHistoryData: function(){
                this.$Progress.start();
                var that = this;
                dtTable = $('#dt-table').DataTable({
                    sDom: '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    processing: true,
                    serverSide: true,
                    pageLength: 100,
                    searching :true,
                    buttons: [],
                    ajax: {
                        "url": "api/virtualTransactionhistory",
                        "data": function (d) {
                            d.from_date = moment(that.from_date).format('YYYY-MM-DD');
                            d.to_date = moment(that.to_date).format('YYYY-MM-DD');
                        },
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                    },
                    deferRender: true,
                    columns: [

                    {render: function(data,type,full){
                        if(full.date != null){
                            return moment(full.date).format('YYYY-MM-DD');
                        }else{
                            return "---";
                        }
                    }},
                    {render: function(data,type,full){
                        if(full.transaction_id != null){
                            return full.transaction_id;
                        }else{
                            return "---";
                        }
                    }},
                    {render: function(data,type,full){
                        if(full.type != null){
                            return full.type;
                        }else{
                            return "---";
                        }
                    }},
                    {render: function(data,type,full){
                        if(full.text != null){
                            return full.text;
                        }else{
                            return "---";
                        }
                    }},
                    {render: function(data,type,full){
                        if(full.type === 'DEBIT'){
                            return full.amount;
                        }else{
                            return "--";
                        }
                    }},
                    {render: function(data,type,full){
                        if(full.type === 'CREDIT'){
                            return full.amount;
                        }else{
                            return "--";
                        }
                    }},
                    {render: function(data,type,full){
                        if(full.running_balance != null){
                            return full.running_balance;
                        }else{
                            return "---";
                        }
                    }},
                    {render: function(data,type,full){
                        if(full.company.name != null && full.type === 'CREDIT'){
                            return full.company.name;
                        }else{
                            return "--";
                        }
                    }},
                    ],
                    "order": [[ 0, "desc" ]],
                    "initComplete": (res,data) => {
                        if (data.records) {
                            if (data.records[0].company.category == 'DISTRIBUTOR') {
                                that.distributor = true;
                            } else {
                                that.distributor = false;
                            }
                        }
                        that.columnHide();
                        that.hasPer = true;
                        that.showBtn = true;
                        setTimeout(function(){
                            $('select.selectpicker').selectpicker();
                        },300);
                        that.$Progress.finish();
                    }
                });

                // $('#custom_search').on( 'keyup', function () {
                //     dtTable.fnFilter(this.value);
                // });
            },

          // generateMT940: function(){
          //   this.$Progress.start();
          //   var formData = {
          //     'from_date': moment(this.from_date).format('YYYY-MM-DD'),
          //     'to_date': moment(this.to_date).format('YYYY-MM-DD'),
          //   }
          //   axios.post('/api/downloadMT940Report',formData,{
          //     responseType: 'blob'
          //   })
          //       .then((response) => {
          //         if(response.status == 200){
          //           this.$Progress.finish();
          //           const url = URL.createObjectURL(new Blob([response.data], {
          //             type: 'text/plain;charset=utf-8;'
          //           }))
          //
          //           const link = document.createElement('a')
          //           link.href = url
          //           link.setAttribute('download', 'mt940.txt')
          //           document.body.appendChild(link)
          //           link.click()
          //           this.$Progress.finish();
          //         }else{
          //           this.showAlertBox('error','There is some problem');
          //         }
          //
          //       }).catch(err => {
          //     console.log(err);
          //     this.$Progress.fail();
          //     this.showAlertBox('error','There is some problem');
          //   });
          // },

            columnHide: function() {
                var column = dtTable.column(7);
                if(this.distributor){
                    console.log('true');
                    column.visible( true );
                }else{
                    console.log('false');
                    column.visible( false );
                }
            }

        },
        mounted() {
			this.can('virtual_corporate_transaction_history|merchant_auto_sweep').then(result => {
			  if (result.virtual_corporate_transaction_history) {
          this.virtual_corporate_transaction_history = result.virtual_corporate_transaction_history;
        }else{
          this.virtual_corporate_transaction_history = result.merchant_auto_sweep;
        }
                this.account_balance = result.vr_balance;
            }).then(result => {
                if(this.virtual_corporate_transaction_history == true){
					this.getVirtualTransactionHistoryData();
                }
            });

        },
    }
</script>
